import { ComponentType } from 'react';
import styled from 'styled-components';
import { ACCENT_PRIMARY, TEXT_100, TEXT_CONTRAST_ON_ACCENT_PRIMARY } from 'style/constants';

export const linkImage = (LinkComponent: ComponentType) => styled(LinkComponent).attrs({
  plain: true,
})`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  & > img {
    max-height: 30px;
  }
`;

export const renderHeaderChildLinks = (LinkComponent: ComponentType) => styled(LinkComponent).attrs({
  plain: true,
})<{ currentlyOn: boolean }>`
  display: flex;
  width: 100%;
  padding: 5px;
  &:hover {
    background: ${ACCENT_PRIMARY};
    & > * {
      color: ${TEXT_CONTRAST_ON_ACCENT_PRIMARY};
    }
  }
  & > * {
    color: ${props => props.currentlyOn ? ACCENT_PRIMARY(props) : TEXT_100(props)};
  }
`;

export const Image = styled.img`
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
`;

export const DisclosureTriangle = styled.span<{ expanded: boolean }>`
  align-self: center;
  border-color: ${TEXT_100} transparent transparent transparent;
  border-style: solid;
  border-width: ${props => props.expanded ? '0 6px 6px 6px' : '6px 6px 0 6px'};
  height: 0px;
  margin-left: 5px;
  width: 0px;
`;
